export const GET_EXCO_KECAMATAN = "GET_EXCO_KECAMATAN";
export const GET_EXCO_KECAMATAN_SUCCESS = "GET_EXCO_KECAMATAN_SUCCESS";
export const GET_EXCO_KECAMATAN_FAIL = "GET_EXCO_KECAMATAN_FAIL";
